<template>
  <header>
   <button class="navbar-toggler navbar-toggler-left" type="button" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation"  v-on:click="closeNav">
        <span style="font-size:30px;cursor:pointer">&#9776;</span>
      </button>
	    <div id="sidebar">
  <div class="closebtn" v-on:click="closeNav">&times;</div>
		<nav class="navbar navbar-default fixed-top navbar-inverse" style="" role="navigation" id="applicationbrandbar">
      <div class="" style="padding: 0px 25px;">
        <a class="navbar-brand" href="#" style="padding-right: 5rem;"><img class="internal-logo" 
		src="../../../assets/img/logo-cargillwhite-help.svg" height="45px" style="padding: 0rem;max-width: 160px;width: auto;height: auto;"></a>
      </div>
			<div class="navbar-collapse" id="navbarNavAltMarkup">
				<ul class="nav navbar-nav" v-for="navItem in navItems">
					<li class="nav-item">
						<router-link :to="{name: navItem.name, query: navItem.query}" active-class="activeHeader" exact>{{user_lang.myprofile}}</router-link>
					</li>
					<li class="nav-item" v-if="isAdmin === 'superadmin' || isAdmin === 'admin'" style="padding-right: 20px;">
						<router-link id="adminLink" :to="adminItem.to" active-class="activeHeader" exact>{{user_lang.adminLabel}}</router-link>
					</li>
					<li class="nav-item" v-if="isAdmin === 'superadmin'" style="padding-right: 20px;">
						<router-link id="tmLink" :to="tmItem.to" active-class="activeHeader" exact>Configuration</router-link>
					</li>
					<li class="nav-item" v-if="isAdmin === 'superadmin'" style="padding-right: 20px;">
						<router-link id="apisetLink" :to="apisetItem.to" active-class="activeHeader" exact>API Settings</router-link>
					</li>
					<li class="nav-item" v-if="isAdmin === 'superadmin'" style="padding-right: 20px;">
						<router-link id="emailLogLink" :to="emailLogItem.to" active-class="activeHeader" exact>Email Logs</router-link>
					</li>
					<!--li class="nav-item" v-if="isAdmin === 'superadmin'" style="padding-right: 20px;">
						<router-link id="reportsLink" :to="reports.to" active-class="activeHeader" exact>Reports</router-link>
					</li-->
				</ul>
        <ul class="nav navbar-nav-admin ml-auto">
        </ul>
		<!--span style="color: #fff; margin-right: 20px;margin-top: 5px;margin-left: 16px;">{{user_lang.selectLang}}:</span-->
		<div style="border-top: 2px solid var(--theme-secondary);">
		<select class="lang-dpd" @change = "changeUserLang" v-model = 'lang'>
		<option v-for= "i in lang_def" v-bind:value="i.langCode">{{i.langName}}</option>
		<!--option value="vi">Vietnamese</option-->
		</select>
		<i class="fa fa-ellipsis-v dots" aria-hidden="true"></i>
		</div>
        <ul class="nav" style="margin-top: 20px;">
          <!--li class="list-inline-item" style="padding-right: 20px;">
					  <router-link :to="HelpItem.to" data-placement="bottom" title="Tire suas duvidas sobre.">
					  <i class="fa fa-question-circle fa-2x fontAwesomeQuestion" aria-hidden="true"></i></router-link>
				  </li-->
				  <li class="list-inline-item">
					  <form class="form-inline">
              <a href="" data-toggle="modal" data-target=".bs-example-modal-sm" data-placement="bottom" title="" role="">
	<div class="help-div"> {{user_lang.logout}} </div></a>
					  </form>
				  </li>
				</ul>
			</div>
    </nav>
    <!-- LOGOUT MODAL -->
    <div tabindex="-1" class="modal bs-example-modal-sm" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-sm">
        <div class="modal-content" style="color: var(--theme-primary);">
          <div class="modal-header" style="color:#000"><h4>{{user_lang.logout}} <i class="fa fa-lock"></i></h4></div>
          <div class="modal-body" style="color:#000"><center>{{user_lang.logoutConfirm}}</center></div>
          <div clss="row">
          <div class="modal-footer" style=""><a class="btn btn-primary btn-block btn-lg" style="background-color: #ececec; color: #000;" data-dismiss="modal">
		  {{user_lang.no}}</a></div>
           <div class="modal-footer" style="border-top: 0; padding-top: 5px;">
		   <a id ="loggout" class="btn btn-primary btn-block btn-lg" href="#" @click.prevent="oktaSignOut">{{user_lang.yes}}</a></div>
           </div>
        </div>
       </div>
    </div>
 </div>
  </header>
</template>
<script>
  import okta from '@/helpers/okta'
  import storage from '@/helpers/storage'
  import { EventBus } from '@/event-bus.js';
  import { locale } from '@/i18n/locale.js';
  import idmApi from '@/idm-api'
  import store from '@/store'
  const apiUrl = process.env.API_URL;
  const onecargilladmingroupid = process.env.ONECARGILL_ADMIN_GROUP_ID;
  const brandDetails = require('../../../brand-details.json');
  const brand = brandDetails.data.filter(i => i.applicationUrls.indexOf(document.location.host) > -1)
  const logoUrl = (brand.length ? brand[0].homepagelogo : 'assets/img/logo-cargillwhite-help.svg')
  console.log(logoUrl)
  var homepagelogo = logoUrl
  if (logoUrl.toLowerCase().indexOf('https:') === -1 && logoUrl.toLowerCase().indexOf('http:') === -1) {
    homepagelogo = require(('../../../' + logoUrl))
  }
  // import store from '@/store'
  export default {
    name: 'applicationBrandBar',
    created() {
      var self = this
      var uid = storage.get('cf-user')
      if (uid !== undefined && uid !== null) {
        var userId = storage.get('cf-user').sub
        console.log(userId)
      } else {
        self.$router.push({path: '/LoggingIn'})
      }
      var adminGroupsArr = []
      var adminAppsArr = []
      idmApi.getListOfAdminConfig(`${apiUrl}/auth/appGroupList`).then(function (response) {
        adminGroupsArr = response.data.map(function(i) {
          // console.log(i.groupId)
          return i.groupId
        })
        adminAppsArr = response.data.map(function(i) {
          return i.applicationId
        })
        userId = storage.get('cf-user').sub
        storage.set('adminConfigMaster', JSON.stringify(response.data))
        storage.set('adminConfigJSON', JSON.stringify(adminGroupsArr))
        storage.set('adminConfigJSONApps', JSON.stringify(adminAppsArr))
        idmApi.getGroupsByUserId(`${apiUrl}/auth/users/${userId}/groups`).then(function (response) {
          storage.set('grpsOfUser', JSON.stringify(response.data))
          storage.set('isServiceAccountGroupMember',
          response.data.filter(x => x.profile.name.toLowerCase().indexOf('service accounts') > -1).length > 0 ? true : false) // eslint-disable-line
          var isSuperAdmin = false
          var isAdmin = false
          // console.log(adminGroupsArr)
          var adminToArr = []
          adminToArr = response.data.filter(function(i) {
            if (adminGroupsArr.indexOf(i.id) > -1) {
              return i
            }
          })
          for (var w = 0; w < response.data.length; w++) {
            if (response.data[w].id === onecargilladmingroupid) {
              isSuperAdmin = true
            }
          }
          if (adminToArr.length > 0) {
            isAdmin = true
          }
          // adminToArr = response.data.filter(i => adminGroupsArr.indexOf(i.id) > -1)
          // for (var w = 0; w < response.data.length; w++) {
          //   if (response.data[w].id === onecargilladmingroupid) {
          //     isSuperAdmin = true
          //   }
          // }
          // if (adminToArr.length > 0) {
          //   isAdmin = true
          // }
          if (isSuperAdmin) {
            self.isAdmin = 'superadmin'
            store.commit('setUserRole', 'superadmin')
          } else if (isAdmin) {
            self.isAdmin = 'admin'
            store.commit('setUserRole', 'admin')
          } else {
            self.isAdmin = 'notadmin'
            store.commit('setUserRole', 'notadmin')
            self.$router.push({ name: 'MyProfile' });
          }
        }).catch(err => {
          self.loading = false;
          console.log("create Insert CF Error: ", err);
        })
      }).catch(err => {
        console.log(err)
      })
      setTimeout(self.assignUserLang(), 1000)
      EventBus.$on('lang', function (language) {
        self.user_lang = self.lang_obj[language]
        self.lang = language
      })
      $(window).resize(function() {
        $('#sidebar').attr('style', '')
        $('.navbar-toggler').attr('style', '')
      });
    },
    mounted() {
      $('.internal-logo').attr('src', homepagelogo)
    },
    methods: {
      assignUserLang() {
        var self = this
        self.user_lang = self.lang_obj[this.lang]
      },
      oktaSignOut() {
        okta.oktaSignOut();
        storage.clearAll();
      },
      changeUserLang: function(e) {
        locale.lang = e.target.value
        this.user_lang = this.lang_obj[e.target.value]
        EventBus.$emit('lang', e.target.value)
      },
      openNav: function(e) {
        // document.getElementById("sidebar").style.display = "block";
        $('#sidebar').css('display', 'block');
        // $('.main-content').css('padding-left', '200px');
        $('.navbar-toggler').css('display', 'none');
        // $('.main-content').css('padding-top', '0px');
      },
      closeNav: function(e) {
        if ($('#sidebar').css('display') === 'none' || $('#sidebar').css('display') === '') {
          this.openNav()
        } else {
          // document.getElementById("sidebar").style.display = "none";
          $('#sidebar').css('display', 'none');
          // $('.main-content').css('padding-left', '0px');
          $('.navbar-toggler').css('display', 'block');
          $('.main-content').css('padding-top', '25px');
        }
      }
    },
    data() {
      return {
        isCargillBrandPortal: document.location.href.toLowerCase().indexOf('cargill') > -1,
        lang: locale.lang,
        lang_obj: locale.lang_obj,
        lang_def: locale.lang_def,
        user_lang: {},
        isAdmin: 'notadmin',
        navItems: [
          {
            name: 'MyProfile',
            displayName: "MyProfile",
            query: {}
          }
        ],
        adminItem: {
          name: 'Admin',
          displayName: "Administração",
          to: '/Admin'
        },
        tmItem: {
          name: 'TM',
          displayName: "TM",
          to: '/TokenManager'
        },
        apisetItem: {
          name: 'apisetting',
          displayName: "apisetting",
          to: '/APISettings'
        },
        emailLogItem: {
          name: 'emaillogs',
          displayName: "emaillogs",
          to: '/SystemLogs'
        },
        reports: {
          name: 'reports',
          displayName: "reports",
          to: '/Reports'
        },
        HelpItem: {
          name: 'Help',
          displayName: "Help",
          to: '/Help'
        }
      }
    }
  }
/* $(window).scroll(function() {
    if ($(document).scrollTop() > 10) {
      $('brand').addClass('shrink');
    } else {
      $('brand').removeClass('shrink');
    }
}); */
$(function () {
    $('[data-toggle="tooltip"]').tooltip()
});
$(document).on('click', function() {
    $('.collapse').collapse('hide');
})
</script>
<style scope>
/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=- Brand Bar =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-*/
/*body {
    padding-top:64px;
}*/
.fixed-top-2 {
    margin-top: 0;
}
.right {
	background: none
}
.btn-navbar {
	color: #fff;
	border-radius:0;
	background: var(--theme-primary);
	border: 0px;
	padding: 8px 20px;
  border: 0 none;
  font-weight: 400;
  letter-spacing: 1px;
	cursor: pointer;
}
.btn-navbar:hover {
	color: #fff;
	background: #D9BE5F;
	transition: all 0.3s ease 0s;
}
.navbar-inverse .navbar-toggler {
    border-color: ;
}
.brandbar  {
	background: #fff;
	margin: 0;
}
/*brand a {
  padding-bottom: 10px !important;
  padding-top: 0px !important;
  transition: all 0.3s ease;
}*/
.navbar-toggleable-md{
	min-height: 80px;
}
.navbar-toggler {
	margin-top: 20px;
  background-color: var(--theme-primary);
  z-index:9999
}
.navbar-collapse {
	padding: 30px 0;
}
ul.list-inline {
	padding: 0;
	margin: 0;
	border-left: 1px solid #CECECB;
  padding:0px;
}
.list-inline-item {
	padding:0px;
}
.fontAwesomeQuestion {
	margin-left:0px;
	vertical-align: middle;
  color: var(--theme-primary);
}
.fontAwesomeQuestion:hover, .fa-sign-out:hover {
  color: #fff;
}
.fa-sign-out {
  margin-left:0px;
	vertical-align: middle;
  color: var(--theme-primary);
}
/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=- Nav Bar =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-*/
.activeHeader {
  border-left: solid 4px var(--theme-primary);
 padding-top: 15px;
    padding-bottom: 10px;
}
.navbar-default{
  margin: 0; /* you don't need add this line
	padding: 0 35px;*/
  border-radius: 0px;
	background-color:var(--theme-secondary);
}
.navbar-nav > li > a {
	color: #fff;
  margin-right: 10px;
  white-space:nowrap;
  padding-left: 16px;
  font-size: 14px;
  font-family: r-med;
}
.navbar-nav > li > a:hover,
.navbar-nav > li > a:focus {
	border-left: 4px solid var(--theme-primary);
	padding-top: 15px;
    padding-bottom: 10px;
	text-decoration: none;
	padding-left:10px !important;
}
.navbar-nav > .nav-item:hover,
.navbar-nav > .nav-item:focus {
	background:#323b3c
}
.navbar-nav > .active > a,
.navbar-nav > .active > a:hover,
.navbar-nav > .active > a:focus {
	background-color: #454c56;
	border-left: 4px solid #fff;
	background-repeat: no-repeat;
	padding-top: 15px;
    padding-bottom: 10px;
	text-decoration: none;
}
.navbar-nav-admin > li > a {
	color: #fff;
	margin-right: 20px;
  border-right: 0px solid #878a8f;
  padding-right: 0px;
}
.navbar-nav-admin > li > a:hover,
.navbar-nav-admin > li > a:focus {
	background-color: #454c56;
  border-left: 4px solid var(--theme-primary);
	padding-top: 15px;
    padding-bottom: 10px;
	text-decoration: none;
  border-right: 0px solid #878a8f;
}
.navbar-nav-admin > .active > a,
.navbar-nav-admin > .active > a:hover,
.navbar-nav-admin > .active > a:focus {
	background-color: #454c56;
	border-top: 0px solid #fff;
	border-left: 0px solid #fff;
	background-repeat: no-repeat;
	padding-top: 10px;
    padding-bottom: 10px;
	text-decoration: none;
  border-right: 0px solid #878a8f;
}
/*.nav-item {
  color:#000;
}*/
.list-inline-item-help > li >a  {
	color: #fff;
	margin-right: 40px;
  border-right: 2px solid #878a8f;
  padding-right: 0px;
}
.list-inline-item-help > li  > a:hover,
.list-inline-item-help > li  > a:focus {
	background-color: #454c56;
  border-top: 0px;
  border-left: 0px;
	padding-top: 0px;
	text-decoration: none;
  border-right: 0px solid #878a8f;
}
.list-inline-item-help > .active > a,
.list-inline-item-help > .active > a:hover,
.list-inline-item-help > .active > a:focus {
	background-color: #454c56;
	border-top: 0px solid #fff;
	border-left: 0px solid #fff;
	background-repeat: no-repeat;
	padding-top: 10px;
    padding-bottom: 10px;
	text-decoration: none;
  border-right: 0px solid #878a8f;
}
.disabled-top-nav-link {
  user-select: none;
  cursor: not-allowed;
}
.disabled-top-nav-link a {
  color: #cdcdcd !important;
  pointer-events: none;
}
li.nav-item {
padding-top: 10px;
    padding-bottom: 10px;
}
.navbar-brand
{
  width: 100%;
  left: 0;
  top: 0;
  /*text-align: left;*/
  margin: auto;
  padding:20px 0;
}
.modal-open {
    overflow: hidden;
    padding-right: 0px !important;
}
.btn-primary {
  border-radius: 0;
}
.btn-primary:hover {
  background-color: var(--theme-primary);
  border: 1px solid var(--theme-primary);
}
/* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=- Media Queries =-=-=-=-=-=-=-=-=-=-=-=-=-=-=- */
@media screen and (max-width: 400px) {
  .navbar-nav > li > a:hover,
  .navbar-nav > li > a:focus {
    background-color: #454c56;
    border-top: 0px solid var(--theme-primary);
    border-left: 0px solid var(--theme-primary);
    padding-top: 11px;
    text-decoration: none;
  }
  .li-navitem {
    text-align: left;
  }
  .navbar-collapse {
    padding: 10px 0px;
  }
}
/* Small devices (landscape phones, 576px and up) */
@media (min-width: 325px) and (max-width: 991px) {
  .list-inline-item-help > li  > a:hover,
  .list-inline-item-help > li  > a:focus {
    background-color: #454c56;
    border-top: 0px;
    border-left: 0px;
    padding-top: 0px;
    text-decoration: none;
    border-right: 0px solid #878a8f;
  }
  .list-inline-item-help > .active > a,
  .list-inline-item-help > .active > a:hover,
  .list-inline-item-help > .active > a:focus {
    background-color: #454c56;
    border-top: 0px;
    border-left: 0px;
    background-repeat: no-repeat;
    padding-top: 15px;
    text-decoration: none;
    border-right: 0px solid #878a8f;
  }
 .navbar-nav-admin > li > a:hover,
.navbar-nav-admin > li > a:focus {
  border-top: 0;border-left: 0;
}
  .navbar-nav > li > a:hover,
  .navbar-nav > li > a:focus {
    background-color: #454c56;
    border-top: 0px;border-left: 0;
    padding-top: 11px;
    text-decoration: none;
  }
  .activeHeader {
    border-left: 0px;
  }
  .navbar-collapse {
    border-top: 1px solid transparent;
    border-left: 1px solid transparent;
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.1);
  }
  .navbar-nav {
    float: none!important;
  }
  .navbar-nav>li {
    float: none;
  }
  .navbar-nav>li>a {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .fontAwesomeQuestion {
    margin-top: 10px;
  }
  .fa-sign-out {
    float: left;
    margin-top: 50px;
    margin-left: -50px;
    vertical-align: middle;
    color: var(--theme-primary);
  }
}
.help-div{
position: absolute;
    bottom: 0px;
    background: var(--theme-primary);
    z-index: 9999;
    width: 99%;
    padding: 10px;
    cursor: pointer;
    color: #fff;outline: 1px solid var(--theme-primary);
        font-size: 16px;
    font-family: r-med;
	}
.navbar-nav{margin-bottom: 20px;}
#applicationbrandbar{
max-width: 200px !important;
height: 100% !important;
padding:0px;
}
.activeHeader{padding-left:10px !important}
.nav-item {
margin-top:5px
}
.closebtn{
    font-size: 35px;
    z-index: 9999999;
    position: absolute;
    color: #fff;
    left: 170px;
    top: -10px;
	cursor:pointer}
.activeHeader {
  border-left: solid 4px var(--theme-primary);
  padding-top: 15px;
    padding-bottom: 10px;
}
.lang-dpd option {
    background:  var(--theme-secondary);
    height: 35px;
	font-size: 14px;
	font-family: r-med;
	}
.lang-dpd{
    background:  transparent;
    color: #fff;
    border: 0px !important;
    width: 100%;
    margin: 16px 0px;
    padding: 0px 13px;
    height: 35px;
	-webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
	-ms-appearance: none;
	z-index: -1;
	font-size: 14px;
	font-family: r-med;
    }
@media screen and (max-width: 767px) {
.navbar-toggler{display:block}
.closebtn{display:block}
#sidebar{display:none}
.main-content{padding-left:0px}
}
@media screen and (min-width: 768px) {
.navbar-toggler{display:none}
.closebtn{display:none}
#sidebar{display:block}
.main-content{padding-left:200px}
}
.dots{font-size: 20px;
cursor:pointer;
    color: #fff;
    float: right;
	z-index:1;
    margin-top: -44px;
	margin-right:10px}
.nav-item: hover {
	background: #fff;
	transition: all 0.3s ease 0s;
}
@font-face {
  font-family: "r-thin";
  src: local(Roboto Thin), url("../../../assets/font/roboto/Roboto-Thin.eot");
  src: url("../../../assets/font/roboto/Roboto-Thin.eot?#iefix") format("embedded-opentype"),
  url("../../../assets/font/roboto/Roboto-Thin.woff2") format("woff2"),
  url("../../../assets/font/roboto/Roboto-Thin.woff") format("woff"),
  url("../../../assets/font/roboto/Roboto-Thin.ttf") format("truetype");
  font-weight: 200; }
@font-face {
  font-family: "r-light";
  src: local(Roboto Light), url("../../../assets/font/roboto/Roboto-Light.eot");
  src: url("../../../assets/font/roboto/Roboto-Light.eot?#iefix") format("embedded-opentype"),
  url("../../../assets/font/roboto/Roboto-Light.woff2") format("woff2"),
  url("../../../assets/font/roboto/Roboto-Light.woff") format("woff"),
  url("../../../assets/font/roboto/Roboto-Light.ttf") format("truetype");
  font-weight: 300; }
@font-face {
  font-family: "r-reg";
  src: local(Roboto Regular), url("../../../assets/font/roboto/Roboto-Regular.eot");
  src: url("../../../assets/font/roboto/Roboto-Regular.eot?#iefix") format("embedded-opentype"),
  url("../../../assets/font/roboto/Roboto-Regular.woff2") format("woff2"),
  url("../../../assets/font/roboto/Roboto-Regular.woff") format("woff"),
  url("../../../assets/font/roboto/Roboto-Regular.ttf") format("truetype");
  font-weight: 400; }
@font-face {
  font-family: "r-med";
  src: url("../../../assets/font/roboto/Roboto-Medium.eot");
  src: url("../../../assets/font/roboto/Roboto-Medium.eot?#iefix") format("embedded-opentype"),
  url("../../../assets/font/roboto/Roboto-Medium.woff2") format("woff2"),
  url("../../../assets/font/roboto/Roboto-Medium.woff") format("woff"),
  url("../../../assets/font/roboto/Roboto-Medium.ttf") format("truetype");
  font-weight: 500; }
@font-face {
  font-family: "r-bold";
  src: url("../../../assets/font/roboto/Roboto-Bold.eot");
  src: url("../../../assets/font/roboto/Roboto-Bold.eot?#iefix") format("embedded-opentype"),
  url("../../../assets/font/roboto/Roboto-Bold.woff2") format("woff2"),
  url("../../../assets/font/roboto/Roboto-Bold.woff") format("woff"),
  url("../../../assets/font/roboto/Roboto-Bold.ttf") format("truetype");
  font-weight: 700; }
select.lang-dpd::-ms-expand {
    display: none;
}
@media all and (-ms-high-contrast:none)
 {
 *::-ms-backdrop, li.nav-item { min-height: 45px !important } /* IE11 */
 }
</style>



// WEBPACK FOOTER //
// brandBar.vue?8fc1d66c